export default "__VITE_ASSET__CGnjIFdQ__"